import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { cloneElement, useEffect } from "react";
import { useOrders } from "../../context/orders/OrdersState";
import OrderItemMobile from "./OrderItemMobile";
import { useAuth, logout, switchUser } from "../../context/auth/AuthState";
import { createOrder } from "../../context/orders/OrdersState";
import { useNavigate } from "react-router-dom"; 
import { updateNotNoCreate } from "../../context/orders/OrdersState";


const OrdersMobile = (props) => {
  const [ordersState, ordersDispatch] = useOrders();
  const { statuses, statusChange ,openCustomers, currentOrder, createdNow, createdFromDuplicate} = ordersState;
  const [authState, authDispatch] = useAuth();
  const navigate = useNavigate(); 
  // loading
  const { user } = authState;
  const defaultItem = {
    customerName: user?.customer,
    title: user?.customer,
  };

  //console.log("Orders in Mobile Component:", props.orders.map(o => o.id));
  useEffect(() => {
    console.log('createdNow', createdNow)
    console.log('currentOrder', currentOrder)
  /*   if (createdNow && currentOrder !== null) {
      console.log('i want to arrive to cart!')
      navigate('/cart/' + currentOrder['id']);
      updateNotNoCreate(ordersDispatch);
    }
 */
    if(createdNow && currentOrder !== null ){
      if ( currentOrder.type == 'base' && createdFromDuplicate == true) {
        console.log('i duplicated so im here!! yessss')
        updateNotNoCreate(ordersDispatch);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }else {
        console.log('i arrived here alsoooooo')
        navigate('/cart/' + currentOrder['id']);        
        updateNotNoCreate(ordersDispatch);
      }
    }
  }, [createdNow, currentOrder, navigate, ordersDispatch]);
 

  const onClick = (e) => {
    switchUser(authDispatch, { customerId: e.value.customerId });
  };
  const itemRender = (li, itemProps) => {
    const index = itemProps.index;
    const itemChildren = (
      <span title={itemProps.dataItem.customerName}>
      {itemProps.dataItem.customerName}
      </span>
    );
    return cloneElement(li, li.props, itemChildren);
  };

   

  return (
    <div className="orders-container" >
      {props.hasBaseOrder === false && (
        <button
          className="btn new-base-order-btn"
          onClick={()=> createOrder(ordersDispatch, props.customerId, 'base') }
        >
          יצירת הזמנת בסיס
        </button>
      )}
        {/* {props.calanderCreate} */}
        {/* <div className="search_wrapper">
        {openCustomers && props.customersCreate}
             {props.yearsCreate}</div> */}
             
             {(user && user.switchUsers.length>0) && 
          <Tooltip parentTitle={true} anchorElement="target" position="right">
            <DropDownList
              className='switch-user'
              data={user.switchUsers}
              itemRender={itemRender}
              onChange={onClick}
              title={defaultItem.customerName}
              textField="customerName"
              defaultValue={defaultItem}
            />
          </Tooltip>
        }           
             
        {!props.orders.length && <div className="noResault">לא נמצאו תוצאות</div>}
        {props.orders.map(order=>(
            <OrderItemMobile onChangeOrderStatus={props.onChangeOrderStatus} key={order.id} order={order} hasBaseOrder={props.orders?.some(order => order.type === "base")}/>
        ))}
      
      </div>
  );
};

export default OrdersMobile;
